var render = function () {
  var _vm$getSheetFlow, _vm$getCurrentSheetWi, _vm$getCurrentSheetWi2, _vm$getCurrentSheetWi3, _vm$getSheetFlow2, _vm$getCurrentSheetWi4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 bg-white",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('sheet-header', {
    attrs: {
      "sheet": _vm.getCurrentSheetWithItems
    }
  }), _c('b-row', {
    staticClass: "mx-0 mt-3",
    attrs: {
      "align-v": "center"
    }
  }, [_c('form-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "id": "time",
      "label": _vm.$t('event-flow.form.show-time')
    },
    model: {
      value: _vm.extraFunctionFormData.showTime,
      callback: function callback($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showTime", $$v);
      },
      expression: "extraFunctionFormData.showTime"
    }
  }), _c('form-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "id": "brief",
      "label": _vm.$t('event-flow.form.show-brief')
    },
    model: {
      value: _vm.extraFunctionFormData.showBrief,
      callback: function callback($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showBrief", $$v);
      },
      expression: "extraFunctionFormData.showBrief"
    }
  }), _c('form-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "id": "legend",
      "label": _vm.$t('event-flow.form.show-legend')
    },
    model: {
      value: _vm.extraFunctionFormData.showLegend,
      callback: function callback($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showLegend", $$v);
      },
      expression: "extraFunctionFormData.showLegend"
    }
  })], 1), _c('div', {
    staticClass: "event-flow my-3"
  }, [_c('div', {
    attrs: {
      "id": "pdf-canvas"
    }
  }, [_c('event-flow-location-header', {
    attrs: {
      "event-flow-locations": (_vm$getSheetFlow = _vm.getSheetFlow) === null || _vm$getSheetFlow === void 0 ? void 0 : _vm$getSheetFlow.eventFlowLocations,
      "extra-function-form-data": _vm.extraFunctionFormData
    }
  }), _c('div', {
    staticClass: "grid"
  }, [_c('event-flow-grid', {
    attrs: {
      "id": "grid",
      "step": _vm.getStep,
      "start-date-time": (_vm$getCurrentSheetWi = _vm.getCurrentSheetWithItems) === null || _vm$getCurrentSheetWi === void 0 ? void 0 : _vm$getCurrentSheetWi.startedAt,
      "end-date-time": (_vm$getCurrentSheetWi2 = _vm.getCurrentSheetWithItems) === null || _vm$getCurrentSheetWi2 === void 0 ? void 0 : _vm$getCurrentSheetWi2.endedAt,
      "event-flow-items": (_vm$getCurrentSheetWi3 = _vm.getCurrentSheetWithItems) === null || _vm$getCurrentSheetWi3 === void 0 ? void 0 : _vm$getCurrentSheetWi3.sheetItems,
      "event-flow-locations": (_vm$getSheetFlow2 = _vm.getSheetFlow) === null || _vm$getSheetFlow2 === void 0 ? void 0 : _vm$getSheetFlow2.eventFlowLocations,
      "extra-data": _vm.extraFunctionFormData,
      "responsibles": (_vm$getCurrentSheetWi4 = _vm.getCurrentSheetWithItems) === null || _vm$getCurrentSheetWi4 === void 0 ? void 0 : _vm$getCurrentSheetWi4.responsibles,
      "is-sheet": ""
    }
  })], 1)], 1)]), _c('div', [_vm.$store.getters['authenticationStorage/isAuthenticated'] ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.invite-modal",
      modifiers: {
        "invite-modal": true
      }
    }]
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.invite')) + " ")]) : _vm._e(), _c('custom-modal', {
    attrs: {
      "id": "invite-modal",
      "title": _vm.$t('sheet.invite')
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('invite-form-sheet', {
          attrs: {
            "id": "invite",
            "error": _vm.getError,
            "loading": _vm.loading
          },
          on: {
            "submit": _vm.onSubmit,
            "cancel": _vm.close
          }
        })];
      },
      proxy: true
    }])
  }), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.newnewPdf(_vm.getCurrentSheetWithItems);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.pdf.download')) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }